<template>
  <div class="appcontent">
    <div class="nav-header">
      <div class="content" id="navContent">
        <div @click="jump('#Abouta')" class="l">
          <img src="@/assets/m/indexpic/logo.svg" alt="" />
          <!-- <div class="title1">Transformers</div> -->
        </div>
        <img class="r" @click="showNav" src="@/assets/m/menu@2x.png" alt="" />
      </div>

      <van-popup v-model="shows1">
        <div class="navTag">
          <!-- popup内的nav -->
          <div class="navtitle">
            <div class="l logo" @click="jump('#Abouta')">
              <img src="@/assets/m/indexpic/logo.svg" />
              <!-- <div class="title1">Transformers</div> -->
            </div>
            <img
              class="r"
              @click="shows1 = false"
              src="@/assets/m/caidan.png"
              alt=""
            />
          </div>

          <Collapse v-model="activeName" accordion>
            <!--learn-->
            <!-- <a href="index#About"> -->
            <div class="Ecological" @click="jump('#About')">
              <CollapseItem name="About">
                <template #title>
                  {{ type === "zh" ? "About" : "About" }}</template
                >
              </CollapseItem>
            </div>
            <!-- </a> -->
            <!-- <a href="index#Mission"> -->
            <div class="Ecological" @click="jump('#Mission')">
              <CollapseItem name="Mission">
                <template #title>
                  {{ type === "zh" ? "Mission" : "Mission" }}
                </template>
              </CollapseItem>
            </div>
            <!-- </a>
            <a href="index#Service"> -->
            <div class="Ecological" @click="jump('#Service')">
              <CollapseItem name="Service">
                <template #title>
                  {{ type === "zh" ? "Service" : "Service" }}</template
                >
              </CollapseItem>
            </div>
            <!-- </a>
            <a href="index#Stratagem"> -->
            <div class="Ecological" @click="jump('#Stratagem')">
              <CollapseItem name="Stratagem">
                <template #title>
                  {{ type === "zh" ? "Stratagem" : "Stratagem" }}
                </template>
              </CollapseItem>
            </div>
            <!-- </a>
            <a href="index#Team"> -->
            <!-- <div class="Ecological" @click="jump('#Team')">
              <CollapseItem name="Team">
                <template #title>
                  {{ type === "zh" ? "Team" : "Team" }}
                </template>
              </CollapseItem>
            </div> -->
            <!-- </a>
            <a href="index#Contact"> -->
            <div class="Ecological" @click="jump('#Contact')">
              <CollapseItem name="Contact">
                <template #title>
                  {{ type === "zh" ? "Contact" : "Contact" }}
                </template>
              </CollapseItem>
            </div>
            <!-- </a> -->
          </Collapse>
        </div>
      </van-popup>
    </div>
    <div class="content-topa" id="Abouta"></div>
    <div class="content-top">
      <div class="toptitle">
        <img src="../../assets/m/indexpic/uqc.gif" />

        <!-- <div>
          <div>TFSC enables multiple block producers to<span> parallelize block production </span> a decentralized and distributed network</div>
        </div> -->
      </div>
      <div class="topimg">
        <div class="topimgl">
          Based on the decentralized autonomy characteristics of DAO to promote
          the development of global green finance.
          <!-- Based on the decentralizedautonomy characteristics of DAO topromote
          the development of globalgreen finance. -->
        </div>
        <div class="topimgr">
          <img src="../../assets/m/indexpic/aboutuqc.png" />
        </div>
      </div>
    </div>
    <div class="content-top1" id="About">
      <div class="top1titl">
        <div class="about_tit">
          <img src="@/assets/m/indexpic/abouta.png" />
          <!-- <el-progress
            class="progress"
            :percentage="Number(percentage)"
            :color="customColor"
            :stroke-width="5.2"
          ></el-progress> -->
        </div>
        <div class="about_cont">
          <div class="about_contl">
            Unique Capital (UQC) is a research-focused <br />investment firm
            dedicated to blockchain <br />
            infrastructure. We bring together experts in the <br />
            field of blockchain underlying technology who <br />
            share a common belief in decentralization and the <br />
            concept of decentralized autonomous <br />
            organizations (DAOs). We firmly believe that the <br />future of
            blockchain development relies on <br />
            technology-driven solutions, and the importance <br />
            of infrastructure in the advancement of Web3 <br />
            cannot be overstated. Our goal is to support the <br />
            development of decentralized infrastructure and <br />
            related middleware, while generating returns and <br />
            fostering a continuous cycle of value. We strive to <br />
            make meaningful contributions to the true <br />
            builders of the Web3 ecosystem.
          </div>
          <div class="about_contr">
            <img src="@/assets/m/indexpic/about1.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-top1a" id="Mission"></div>

    <div class="content-top2">
      <div class="top2titl">
        <img src="@/assets/m/indexpic/mission.png" />
      </div>
      <div class="top2cont">
        <div class="top2c">
          We are committed to selecting and supporting<br />
          decentralized projects with practical use cases,<br />
          creating value for the development of the<br />
          blockchain ecosystem, and helping them thrive.
        </div>
      </div>
      <div class="top2cont_img">
        <img src="@/assets/m/indexpic/missionaa.png" />
      </div>
      <div class="top2conbox">
        <div class="top2conli">
          <div class="top2text">
            We are committed to growing and developing together<br />
            with projects. Just like the project teams, we support<br />
            long-term aspirations and goals.
          </div>
        </div>
        <div class="top2conli">
          <div class="top2text">
            Our focus is on the value created by the projects <br />themselves,
            and we are dedicated to helping project <br />teams become major
            drivers of decentralized technology<br />
            worldwide.
          </div>
        </div>
        <div class="top2conli">
          <div class="top2text toptext2">
            Our investment portfolio goes beyond infrastructure and
            <br />middleware protocols, encompassing diversified<br />
            projects across different domains within the blockchain<br />
            ecosystem. This approach aims to meet various<br />
            investment needs and risk preferences, providing a wide<br />
            range of opportunities for investors.
          </div>
        </div>
        <div class="top2conli">
          <div class="top2text toptext2">
            Our team is composed of experienced cryptocurrency<br />
            technologists and financial experts, enabling us to blend<br />
            institutional and decentralized expertise. This allows us <br />to
            provide excellent collaborative services to high-<br />quality
            projects.
          </div>
        </div>
      </div>
    </div>
    <div class="content-top2a" id="Service"></div>
    <div class="content-top3">
      <div class="top3titl">
        <img src="@/assets/m/indexpic/serve.png" />
        <div class="top3box top3tit">
          <img class="top3img" src="@/assets/m/indexpic/servea.png" />
          <div class="top3line"></div>
          <!-- <el-progress
            class="progressa"
            :percentage="Number(percentagea)"
            :color="customColor"
            :stroke-width="5"
          ></el-progress> -->
          <div class="top3contx">
            We provide professional blockchain investment management<br />
            services to our limited partners (LPs). This includes asset<br />
            allocation, risk management, and portfolio supervision.<br />
            Based on the clients' goals and risk tolerance, we develop<br />
            personalized investment strategies and regularly assess and
            <br />adjust the investment portfolio to achieve optimal returns<br />
            and risk control.
          </div>
        </div>
        <div class="top3box">
          <img class="top3imga" src="@/assets/m/indexpic/serveb.png" />
          <div class="top3line"></div>
          <!-- <el-progress
            class="progressb"
            :percentage="Number(percentageb)"
            :color="customColor"
            :stroke-width="5"
          ></el-progress> -->
          <div class="top3contx">
            We conduct comprehensive evaluations and due diligence on
            <br />blockchain projects to assess their potential and
            feasibility.<br />
            This includes conducting a thorough analysis of technical
            <br />feasibility, project team, market competitiveness, economic<br />
            models, and other relevant aspects to make informed <br />investment
            decisions.
          </div>
        </div>
        <div class="top3box">
          <img class="top3imgb" src="@/assets/m/indexpic/servec.png" />
          <div class="top3line"></div>
          <!-- <el-progress
            class="progressc"
            :percentage="Number(percentagec)"
            :color="customColor"
            :stroke-width="5"
          ></el-progress> -->
          <div class="top3contx">
            We provide incubation and acceleration services to<br />
            promising blockchain startups. This includes providing<br />
            financial support, technical assistance, marketing promotion,<br />
            and resource connections to help these startups grow <br />rapidly,
            scale their operations, and achieve their goals.
          </div>
        </div>
        <div class="top3box">
          <img class="top3imgc" src="@/assets/m/indexpic/served.png" />
          <div class="top3line"></div>
          <!-- <el-progress
            class="progressd"
            :percentage="Number(percentaged)"
            :color="customColor"
            :stroke-width="5"
          ></el-progress> -->
          <div class="top3contx top3last">
            We conduct in-depth market research in the blockchain<br />
            industry, providing regular market insights reports and
            <br />industry trend analysis to help our partners gain a better<br />
            understanding of industry dynamics and investment<br />
            opportunities. Our research team closely monitors the
            <br />development and innovative trends in the blockchain
            <br />technology sector, offering strategic guidance to LPs
            <br />and partners.
          </div>
        </div>
      </div>
    </div>
    <div class="content-top4a" id="Stratagem"></div>
    <div class="content-top4">
      <div class="top4_main">
        <img class="top4_img" src="@/assets/m/indexpic/startag.png" />
        <div class="startag_box">
          <img class="top4_imgs" src="@/assets/m/indexpic/stra.png" />
          <div class="startag_con">
            The blockchain industry is a technology-driven field, and<br />
            we focus on investing in projects that have innovative<br />
            and forward-looking technologies. This includes<br />
            innovative solutions such as fundamental blockchain <br />protocols,
            distributed applications, smart contracts, and<br />
            privacy protection. We closely follow technological<br />
            development trends and select projects with the<br />
            potential to disrupt the industry for investment.
          </div>
        </div>
        <div class="startag_box">
          <img class="top4_imga" src="@/assets/m/indexpic/stra1.png" />
          <div class="startag_con">
            We have a specific focus on vertical domains in our
            <br />investments. Blockchain technology has vast potential<br />
            across various industries, and we choose to conduct in-<br />depth
            research and invest in specific areas such as L1,<br />
            ZK, DeFi, and others. By gaining a deep understanding of<br />
            their characteristics and pain points, we can select<br />
            projects that offer solutions and achieve better <br />investment
            returns.
          </div>
        </div>
        <div class="startag_box">
          <img class="top4_imgb" src="@/assets/m/indexpic/stra3.png" />
          <div class="startag_con">
            As investors, we actively engage in and promote the<br />
            development of the blockchain industry's ecosystem.<br />
            We establish collaborative relationships with other<br />
            investment firms, incubators, technology providers,<br />
            industry associations, and more to collectively support<br />
            and nurture blockchain projects. By sharing resources,<br />
            experiences, and networks, we provide extensive support<br />
            to projects and play an active role within the entire<br />
            ecosystem.
          </div>
        </div>
        <div class="startag_box">
          <img class="top4_imgc" src="@/assets/m/indexpic/stra4.png" />
          <div class="startag_con">
            We do not place significant emphasis on the background<br />
            or even the anonymous status of project teams.<br />
            However, their execution capability is what we are more<br />
            concerned about. The success and implementation of<br />
            blockchain projects are closely tied to the technical<br />
            proficiency, insight, and Web3 mindset of the team. We<br />
            assess team members' experience, expertise, and <br />cognitive
            abilities through events to ensure they have<br />
            the capability to drive project development and achieve<br />
            success.
          </div>
        </div>
      </div>
    </div>
    <div class="content-top5a" id="Team"></div>
    <!-- <div class="content-top5">
      <div class="top5_main">
        <img src="@/assets/m/indexpic/team.png" />
        <div class="top5_box">
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="content-top6a" id="Contact"></div>
    <div class="content-top6">
      <div class="top6_main">
        <img src="@/assets/m/indexpic/contact.png" />
        <div class="contact_con">
          Please provide us with more information about your project,<br />
          and we will get back to you promptly with specific ideas on<br />
          how to support your organizational processes and achieve<br />
          project outcomes.
        </div>
        <div class="contact_from">
          <el-form ref="form" :model="form" :rules="rules">
            <div class="contact_li">
              <el-form-item prop="fullName">
                <el-input
                  v-model="form.fullName"
                  placeholder="Full fullName"
                  @input="getInfo"
                  class="inpttext"
                ></el-input>
              </el-form-item>
            </div>
            <div class="contact_li">
              <el-form-item prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="E-mail"
                  @input="getInfo"
                  class="inpttext"
                ></el-input>
              </el-form-item>
            </div>
            <div class="contact_li">
              <el-form-item prop="content">
                <el-input
                  type="textarea"
                  placeholder="Information..."
                  v-model="form.content"
                  @input="getInfo"
                  class="textall"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </div>
            <div class="submits" v-if="!btnShow">
              <img src="@/assets/m/indexpic/submit.png" />
            </div>
            <div class="submitsa" v-if="btnShow" @click="submitForm">
              <img src="@/assets/m/indexpic/submita.png" />
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- <div class="content-top7">
      <div class="top7_main">
        <div class="top7_company">
          <div class="company_img">
            <img class="img1" src="@/assets/m/indexpic/foot1.png" />
          </div>
          <div class="company_img">
            <img class="img2" src="@/assets/m/indexpic/foot2.png" />
          </div>
          <div class="company_img">
            <img class="img3" src="@/assets/m/indexpic/foot3.png" />
          </div>
          <div class="company_img">
            <img class="img4" src="@/assets/m/indexpic/foot4.png" />
          </div>
          <div class="company_img">
            <img class="img5" src="@/assets/m/indexpic/foot5.png" />
          </div>
          <div class="company_img">
            <img class="img6" src="@/assets/m/indexpic/foot6.png" />
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
import { GetcommitApply } from "@/assets/server/api.js";
import Vue from "vue";
const echarts = require("echarts");
export default {
  components: {
    // Login,
    // CheckUser,
    Collapse,
    CollapseItem,
    // ShowMoney,
  },
  data() {
    return {
      form: {
        intro: "", //介绍
        Name: "",
        emails: "",
      },
      rules: {},
      shows1: false, // popup显示隐藏
      shows2: false,
      moneyAddress: "",
      activeName: "",
      // navList: navList,
      headerclass: true,
      show: false,
      type: "",
      userName: "",
      isLogin: true,
      dialogType: "",
      dialogVisible: false,
      userMenu: false,
      usersStatus: "",
      // currentPath: "/m/Intro", //当前路由地址
      Scolor: "",
      form: {
        content: "", //介绍
        fullName: "",
        email: "",
      },
      rules: {
        // 第一部分效验开始
        fullName: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          { min: 1, max: 10, message: " Less than 50 bytes", trigger: "blur" },
        ],

        email: [
          {
            required: true,
            type: "email",
            message: "Please fill this in email",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: " Less than 100 bytes",
            trigger: "blur",
          },
        ],

        content: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: " Less than 1000 bytes",
            trigger: "blur",
          },
        ],

        // 第一部分效验结束
      },
      btnShow: false,
      widthPre: "",
      percentage: 16,
      percentagea: 10,
      percentageb: 10,
      percentagec: 10,
      percentaged: 10,
      customColor: "#0B27F1",
      timer: "",
    };
  },
  computed: {},
  created() {},
  destroyed() {},
  mounted() {
    window.addEventListener("scroll", this.scrollFn, false);
  },
  methods: {
    getInfo() {
      if (
        this.form.fullName.length >= 1 &&
        this.form.email.length >= 1 &&
        this.form.content.length >= 1
      ) {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
    },
    scrollFn() {
      let page = document.body.scrollHeight;
      let client = document.documentElement.clientHeight;
      let comend = page - client;
      let scrTop = document.documentElement.scrollTop + 220;
      // console.log(scrTop);
      this.percentage = Number(Math.round((scrTop / comend) * 10000) / 10);
      // console.log(this.percentage);
      if (this.percentage > 100) {
        this.percentage = 100;
      }
      this.percentagea =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 280;
      this.percentageb =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 290;
      this.percentagec =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 300;
      this.percentaged =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 310;

      if (this.percentagea >= 100) {
        this.percentagea = 100;
      } else if (this.percentagea <= 0) {
        this.percentagea = 10;
      }

      if (this.percentageb >= 100) {
        this.percentageb = 100;
      } else if (this.percentageb <= 0) {
        this.percentageb = 10;
      }
      if (this.percentagec >= 100) {
        this.percentagec = 100;
      } else if (this.percentagec <= 0) {
        this.percentagec = 10;
      }
      if (this.percentaged >= 100) {
        this.percentaged = 100;
      } else if (this.percentaged <= 0) {
        this.percentaged = 10;
      }
    },
    async submitForm() {
      this.$refs.form.validate(async (success) => {
        if (success) {
          this.ImgUrl = this.ImgUrla;
          let formData = new FormData();
          let item = this.form;
          console.log(item);
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetcommitApply(formData);
          if (data.code == 200) {
            this.$message("Thank you for submitting the form!");
            this.$refs.form.resetFields();
            this.btnShow = false;
          } else {
            this.$message("This field is required");
          }
        } else {
          this.$message("Out of byte range or This field are not filled in ");
          return false;
        }
      });
    },
    originNavClick() {
      this.$router.push("/");
      if (sessionStorage.getItem("currentPath")) {
        sessionStorage.removeItem("currentPath");
      }
      this.currentPath = "";
    },
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },

    showUserMenu(item) {
      this.userMenu = true;
      this.show = false;
      this.showsubmenu = true;
    },
    showUserInfo(name) {
      this.isLogin = false;
      this.userName = name;
    },
    check() {
      this.dialogVisible = true;
      this.dialogType = "check";
      this.shows2 = true;
      this.shows1 = false;
    },
    mEnter() {
      clearInterval(this.timer); //鼠标移入清除定时器
    },
    jump(id) {
      this.shows1 = false;
      var height = document.body.clientHeight;

      var aa = document.querySelector(id);
      // aa.style.backgroundColor="red";
      setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 500);
      aa.scrollTo(0, height);
      document.querySelector(id).scrollIntoView(true);
      document.querySelector(id).scrollIntoView();
    },
    showNav() {
      this.shows1 = true;
    },
  },
};
</script>
<style lang="less">
@font-face {
  font-family: "Roboto";
  font-weight: normal;
  font-style: normal;
}
.el-progress__text {
  display: none;
}
.el-progress {
  background: none;
  // width: 80px;
  // position: relative;
  // height: 10px;
  // border: 1px solid red;
}
.el-progress-bar__outer {
  background: none;
}
.el-progress-bar__inner {
  background: #0b27f1;
  border-radius: 59px 59px 59px 59px;
}
.el-input__inner {
  width: 694px;
  height: 100px;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 3px solid #333333;
}
.el-textarea__inner {
  width: 694px;
  height: 400px;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 3px solid #333333;
}
.van-collapse-item__wrapper {
  background: #fff;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px !important;
}

.van-collapse-item__content {
  background: #fff;
  opacity: 0.5;
}
.van-collapse {
  position: absolute;
  left: 30px;
  width: 690px;
  overflow-y: scroll;
  height: 92%;
  margin-top: 107px;
}
.van-cell {
  height: 120px;
  // border: 1px solid red;
  line-height: 80px;
  opacity: 0.95 !important;
}
.nav-header {
  width: 100vw;
  height: 110px;

  .content {
    position: fixed;
    top: 0px !important;
    left: 0px;
    right: 0px;
    height: constant(100);
    height: env(100);
    z-index: 99;
    padding-right: 42px;
    height: 110px;
    display: flex;
    background: #fff;
    justify-content: space-between;
    align-items: center;
    .title1 {
      font-size: 30px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 800;
      color: #141414;
      line-height: 39px;
      margin-left: 10px;
    }
    .subTitle {
      font-family: Roboto-Medium, Roboto;
    }
    div {
      display: flex;
      align-items: center;
    }
    .l {
      width: 231.69px;
      height: 58.67px;
      opacity: 1;
      margin-right: 17px;
      margin-left: 50px;
      img {
        width: 127px;
        height: 52px;
      }
    }
    .logo {
      width: 232px;
      height: 42.58px;
    }
    .l2 {
      width: 84px;
      height: 62px;
      margin-left: 15px;
    }
    .r {
      width: 70px;
      height: 70px;
    }
  }
  .navTag {
    width: 100vw;
    height: 100vh;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    overflow-y: scroll;
    display: inline-flex;
    flex-direction: column;
    // background: #131313;
    background: #fff;
    .Ecological {
      i {
        display: none !important;
      }
      .van-collapse-item__wrapper {
        display: none;
      }
    }
    .navtitle {
      width: 100%;
      height: 107px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
      }
      .l {
        width: 231.69px;
        height: 108.6px;
        opacity: 1;
        margin-right: 17px;
        margin-left: 50px;
        img {
          width: 127px;
          height: 55px;
        }
      }
      .title1 {
        font-family: Roboto-Medium, Roboto;
        font-size: 30px;
        font-weight: 800;
        color: #141414;
        line-height: 110px;
        text-align: left;
        margin-left: 10px;
      }
      .r {
        width: 70px;
        height: 70px;
        margin-right: 40px;
      }
    }
    van-cell {
      height: 120px;
      background: rgba(0, 0, 0, 0.04) !important;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
    a {
      font-size: 26px;
      font-family: Roboto-Medium, Roboto;
      font-weight: normal;
      line-height: 33px;
      color: rgba(20, 20, 20, 0.60000002) !important;
    }
    .van-cell__title {
      height: 120px;
      font-size: 32px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #3d3d3d;
      line-height: 80px;
      text-align: left;
    }
    i.van-icon {
      padding-right: 25px;
      padding-top: 22px;
      color: #141414;
      width: 12px;
      height: 12px;
      opacity: 1;
    }
    .van-collapse-item__content {
      margin-right: 30px;
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: normal;
      color: rgba(20, 20, 20, 0.6000000238418579) !important;
      opacity: 1 !important;
    }
    .van-collapse-item-text {
      font-size: 26px;
      font-family: Roboto-Medium, Roboto;
      font-weight: normal;
      line-height: 33px;
      padding-top: 20px;
      padding-bottom: 20px;
      div {
        padding-top: 20px;
        padding-left: 20px;
        a {
          display: block;
        }
      }
      .ahightlight {
        color: #fff;
      }
    }
    .highlight {
      color: #cf61dc;
      opacity: 1;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: normal;
    }
  }
  .bottom {
    flex: 1;
    width: 100%;
    background: #202020;
    border-radius: 0px 0px 0px 0px;
  }
  .bot {
    width: 650px;
    height: 660px;
    left: 50px;
    position: relative;
    top: 20px;
    text-align: center;
    .dialog {
      margin: 0 auto;
      margin-bottom: 60px;
      img {
        width: 100px;
        height: 100px;
        opacity: 1;
      }
    }
    .community {
      margin-bottom: 40px;
      img {
        margin-right: 40px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.01);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
    }
    .bottom-copyright {
      margin: 0 20px 10px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>

<style lang="less" scoped>
@font-face {
  font-family: "HarmonyOS Sans SC-Regular";
  src: url("../../assets/font/HarmonyOS_Sans_SC_Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

.appcontent {
  width: 750px;
  margin: 0px auto 0px auto;
  background: #fff;
  text-align: center;
  .content-topa {
    background: #fff;
    height: 70px;
    width: 750px;
  }
  .content-top {
    width: 100%;

    // height: 500px;
    background: #fff;
    // padding-top: 28px;
    .toptitle {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
      width: 691px;
      // height: 108px;
      margin-bottom: 75px;
      img {
        width: 691px;
        // height: 300px;
      }
      // height: 532px;

      div {
        width: 690px;
        // height: 470px;
        font-size: 56px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 60px;
      }
      // line-height: 112px;
      span {
        color: #cf61dc;
      }
    }
    .topimg {
      display: flex;
      justify-content: space-between;
      width: 693px;
      margin: 0 auto;
      .topimgl {
        width: 490px;
        text-align: left;
        height: 126px;
        font-size: 24px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
      }
      .topimgr {
        margin-top: 99px;
        img {
          width: 63px;
          height: 15px;
        }
      }
    }
  }
  .content-top1 {
    padding-top: 26px;
    width: 750px;
    // height: 640px;
    background: #fff;
    opacity: 1;
    .top1titl {
      //  position: relative;
      width: 693px;
      margin: 0 auto;
      .about_tit {
        margin-top: 100px;
        img {
          width: 318px;
          height: 69px;
          margin-right: 457px;
          // border: 1px solid red;
        }
        .progress {
          position: relative;
          left: 120px;
          top: -56px;
          width: 320px;
        }
      }
      .about_cont {
        display: flex;
        justify-content: space-between;
        // padding-bottom: 100px;
        .about_contl {
          margin-top: 59px;
          //  border: 1px solid red;
          width: 595px;
          height: 672px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          // border: 1px solid red;
          color: #333333;
          line-height: 42px;
          text-align: left;
        }
        .about_contr {
          margin-top: 506px;
          img {
            width: 53px;
            height: 213px;
          }
        }
      }
    }
  }
  .content-top1a {
    width: 750px;
    height: 100px;
    background: #fff;
  }
  .content-top2a {
    width: 750px;
    height: 120px;
    background: #fff;
  }
  .content-top2 {
    width: 750px;
    // height: 1669px;
    background: #2f47ee;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding-top: 80px;
    .top2titl {
      display: flex;
      width: 693px;
      margin: 0 auto;
      // margin-top: 80px;
      img {
        width: 422px;
        height: 57px;
        margin-left: 134px;
      }
    }
    .top2cont {
      margin-top: 21px;
      margin-bottom: 60px;
      .top2c {
        width: 538px;
        height: 168px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 42px;
        margin: 0 auto;
        text-align: left;
        word-spacing: -1px;
      }
    }
    .top2cont_img {
      margin-bottom: 26px;
      img {
        width: 358px;
        height: 38px;
      }
    }
    .top2conbox {
      padding-bottom: 28px;
      .top2conli {
        width: 694px;
        //height: 204px;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 4px solid #ffffff;
        margin: 0 auto;
        margin-bottom: 28px;
        // .toptext2 {
        //   height: 330px !important;
        // }
        .top2text {
          width: 641px;
          // height: 168px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 42px;
          word-spacing: -2px;
          margin: 0 auto;
          padding-top: 18px;
          text-align: left;
          margin-bottom: 22px;
        }
      }
      .top2conli:hover {
        width: 694px;

        background: #ff00ff;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 4px solid #ffa2ff;
        // .toptext2:hover {
        //   height: 330px !important;
        // }
        // .top2text:hover {
        //   height: 168px;
        // }
      }
    }
  }
  .content-top3 {
    width: 750px;
    background: #ffffff;
    .top3titl {
      width: 691px;
      margin: 0 auto;
      // padding-top: 20px;
      img {
        width: 273px;
        height: 57px;
      }
    }
    .top3tit{
        padding-top: 80px !important;
    }
    .top3box {
      padding-top: 140px;
      .top3img {
        width: 250px;
        height: 85px;
        margin-bottom: 8px;
      }
      .top3imga {
        width: 330px;
        height: 87px;
        margin-bottom: 8px;
      }
      .top3imgb {
        width: 262px;
        height: 77px;
        margin-bottom: 8px;
      }
      .top3imgc {
        width: 319px;
        height: 94px;
        margin-bottom: 8px;
      }

      .top3line {
        width: 54px;
        height: 8px;
        background: #0b27f1;
        border-radius: 59px 59px 59px 59px;
        opacity: 1;
        margin-left: 316px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .progressa {
        position: relative;
        left: 256px;
        top: 0px;
        width: 164px;
        //border: 1px solid red;
      }
      .progressb {
        position: relative;
        left: 256px;
        top: 0px;
        width: 164px;
        //border: 1px solid red;
      }
      .progressc {
        position: relative;
        left: 256px;
        top: 0px;
        width: 164px;
        //border: 1px solid red;
      }
      .progressd {
        position: relative;
        left: 256px;
        top: 0px;
        width: 164px;
        //border: 1px solid red;
      }
      .top3contx {
        width: 694px;
        margin-top: 20px;
        // height: 336px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
        word-spacing: -1px;
        text-align: center;
        // border: 1px solid red;
      }
      // .top3last {
      //   padding-bottom: 100px;
      // }
    }
  }
  .content-top4a {
    width: 750px;
    height: 120px;
    background: #fff;
  }
  .content-top4 {
    width: 750px;
    height: 2236px;
    background: #2f47ee;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .top4_main {
      padding-top: 100px;
      .top4_img {
        width: 300px;
        height: 70px;
        margin-left: 12px;
      }

      .startag_box {
        width: 694px;
        // height: 527px;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 4px solid #ffffff;
        margin: 0 auto;
        margin-top: 28px;

        .top4_imgs {
          width: 540px;
          height: 39px;
          margin-top: 26px;
          margin-right: 101px;
        }
        .top4_imga {
          width: 405px;
          height: 31px;
          margin-top: 26px;
          margin-right: 232px;
        }
        .top4_imgb {
          width: 442px;
          height: 39px;
          margin-top: 26px;
          margin-right: 194px;
        }
        .top4_imgc {
          width: 480px;
          height: 39px;
          margin-top: 26px;
          margin-right: 161px;
        }
        .startag_con {
          text-align: left;
          margin-left: 28px;
          margin-top: 20px;
          margin-bottom: 30px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 42px;
          // word-spacing: -2px;
        }
      }
      .startag_box:hover {
        width: 694px;
        // height: 204px;
        background: #ff00ff;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 4px solid #ffa2ff;
      }
    }
  }
  .content-top5a {
    background: #2f47ee;
    width: 750px;
    height: 28px;
  }
  .content-top5 {
    background: #fff;
    width: 750px;
    .top5_main {
      width: 694px;
      margin: 0 auto;
      img {
        margin-top: 100px;
        width: 208px;
        height: 66px;
      }
      .top5_box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 16px;
        .top5_boxul {
          position: relative;
          .top5_boxli {
            width: 333px;
            height: 381px;
            background: #2f47ee;
            border-radius: 24px 24px 24px 24px;
            opacity: 1;
            border: 0px solid #000000;
            img {
              width: 39px;
              height: 303px;
              position: absolute;
              top: -100px;
              right: 0;
            }
          }
          .top5_text {
            margin-top: 21px;
            font-size: 36px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            letter-spacing: 1px;
          }
          .top5_con {
            font-size: 24px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #000000;
            line-height: 32px;
            margin-top: 10px;
            margin-bottom: 32px;
          }
        }
        .top5_boxul:nth-child(5) {
          margin-left: 180px;
          margin-bottom: 0px !important;
        }
      }
    }
  }
  .content-top6a {
    background: #fff;
    height: 120px;
  }
  .content-top6 {
    background: #fff;
    // margin-top: 69px;
    .top6_main {
      width: 694px;
      margin: 0 auto;
      img {
        width: 383px;
        height: 55px;
        margin-right: 304px;
      }
      .contact_con {
        width: 694px;
        height: 192px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        text-align: left;
        margin-top: 28px;
        margin-bottom: 28px;
      }
      .contact_from {
        padding-bottom: 120px;
        .contact_li {
        }
        .submits {
          width: 694px;
          height: 108px;
          border-radius: 24px 24px 24px 24px;
          opacity: 1;
          border: 6px solid #000000;
          line-height: 108px;
          text-align: center;
          img {
            width: 130px;
            height: 29px;
            margin-top: 39px;
            margin-left: 282px;
          }
        }
        .submitsa {
          width: 694px;
          height: 108px;
          border-radius: 24px 24px 24px 24px;
          opacity: 1;
          background: #2f47ee;
          // border: 6px solid #000000;
          line-height: 108px;
          text-align: center;
          img {
            width: 130px;
            height: 29px;
            margin-top: 39px;
            margin-left: 282px;
          }
        }
      }
    }
  }
  .content-top7 {
    background: #fff;
    width: 750px;
    .top7_main {
      width: 694px;
      margin: 0 auto;
      .top7_company {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .company_img {
          width: 305px;
          height: 91px;
          // border: 1px solid #999;
          margin-bottom: 63px;
          margin-right: 56px;
          .img1 {
            width: 275px;
            height: 91px;
          }
          .img2 {
            width: 294px;
            height: 47px;
          }
          .img3 {
            width: 344px;
            height: 45px;
          }
          .img4 {
            width: 223px;
            height: 60px;
          }
          .img5 {
            width: 49px !important;
            height: 60px !important;
          }
          .img6 {
            width: 223px;
            height: 57px;
          }
        }
        .company_img:nth-child(even) {
          margin-right: 0px !important;
        }
      }
    }
  }
}
</style>
